const color = {
  backgroundColor: '#FFBBBB',
  BubbleColor: '#FFFDF8',
  titleTextColor: '#491E09',
  allMainColor: '#FF417D',
};

const layout = {
  mainWidth: '650px',
};

const breakpoint = {
  desktop: 1440,
  tablet: 650,
  mobile: 475,
  mobileMini: 365,
};

const device = {
  desktop: `(max-width: ${breakpoint.desktop}px)`,
  tablet: `(max-width: ${breakpoint.tablet}px)`,
  mobile: `(max-width: ${breakpoint.mobile}px)`,
  mobileMini: `(max-width: ${breakpoint.mobileMini}px)`,
};

export const theme = {
  device,
  color,
  layout,
};
